<script setup lang="ts">
import PrimeConfirmDialog from "primevue/confirmdialog"
import PrimeConfirmPopup from "primevue/confirmpopup"
import PrimeDynamicDialog from "primevue/dynamicdialog"
import Toast from "primevue/toast"
import { inject } from "vue"
import { useRoute } from "vue-router"
import LayoutDefault from "@/commons/layouts/LayoutDefault.vue"
import { isInitializedSymbol } from "@/main"

const route = useRoute()
const isInitialized = inject(isInitializedSymbol)
</script>

<template>
  <component :is="route.meta.layout || LayoutDefault" v-if="isInitialized" />
  <toast />
  <prime-dynamic-dialog />
  <prime-confirm-popup group="popup" />
  <prime-confirm-dialog group="dialog" />
</template>

<style lang="scss">
@use "@/commons/styles/fonts";

@layer normalize, primevue, ui;

:root {
  --color-primary: #1ebdef;
  --color-secondary: #52e8cd;
  --color-tertiary: #00fdff;
  --color-dark: #002f44;

  --color-on-primary: #fff;
  --color-on-secondary: #000;
  --color-on-tertiary: #000;
  --color-on-dark: #fff;

  --font-family-sans: "Poppins", sans-serif;
  --font-family-mono: "Chivo Mono", monospace;

  --animation-duration__expand: 0.3s;
}

@layer normalize {
  * {
    margin: 0;
    padding: 0;
    min-width: 0;
  }

  // Vuetify's modified styles
  button,
  input,
  select,
  textarea {
    background-color: transparent;
    border-style: none;
  }

  // Reset heading weights
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-weight: normal;
  }
}

@layer primevue {
  .p-confirm-popup-message {
    white-space: pre-line;
  }
}

body {
  font-family: var(--font-family-sans);
  color: var(--color-dark);
}

/* Used in Prime's DataTable to align header to the right */
/* Please see @/commons/utils/primevue.ts */
.prime-datatable-header-right .p-column-header-content {
  justify-content: flex-end !important;

  .p-column-title {
    text-align: right;
  }
}

/* TODO: Remove after https://gitlab.com/callirius-tech/callirius/-/issues/149 */
.p-multiselect-filter-icon,
.p-input-icon-left > i,
.p-input-icon-left > svg,
.p-input-icon-right > i,
.p-input-icon-right > svg {
  margin-top: -0.5rem;
}
</style>
